import { type ReactElement } from 'react';

interface DraftProgressProps {
  packIndex: number;
  pickIndex: number;
  totalPacks: number;
  cardsInPack: number;
  setName: string;
}

export default function DraftProgress({ packIndex, pickIndex, totalPacks, cardsInPack, setName }: DraftProgressProps): ReactElement {
  const packNumber = packIndex + 1;
  const pickNumber = pickIndex + 1;

  return (
    <div className="flex items-center justify-between border-b border-zinc-700/50 bg-zinc-800/50 px-4 py-2">
      <div className="flex items-center gap-4">
        <h2 className="text-sm font-medium text-zinc-100">{setName}</h2>
        <div className="flex items-center gap-2">
          <span className="rounded bg-zinc-700 px-2 py-0.5 text-xs font-medium text-zinc-200">
            Pack {packNumber}/{totalPacks}
          </span>
          <span className="rounded bg-zinc-700 px-2 py-0.5 text-xs font-medium text-zinc-200">Pick {pickNumber}</span>
        </div>
      </div>
      <span className="text-xs text-zinc-500">{cardsInPack} cards remaining</span>
    </div>
  );
}
